import React, { useEffect, useState } from 'react'
import axios from 'axios'
import { Input, AutoComplete, Form, message } from 'antd'
import IntlMessages from '../util/IntlMessages'
import {
  CURRENT_VERSION,
  INDEX_DB_NAME,
  INDEX_DB_PRODUCTS_COLUMNS,
  INDEX_DB_TABLES,
  PRODUCT_NAME_INDEX
} from '../constants/IndexDBData'
import {
  StringIsNullOrEmpty,
  getDecryptID,
  isEmptyObject,
  isString,
  loadSearchSelectedProduct,
  saveProductsToIndexedDB
} from '../appRedux/actions'
import { loadFetchProducts } from '../appRedux/actions'
import { useDispatch, useSelector } from 'react-redux'
import {
  AUTOCOMPLETE_SEARCH_FROM,
  PROD_SEARCH_ENTITIES
} from '../constants/ProductSearch'
import { autocompleteSearch } from '../appRedux/actions/IndexDBActions'
import { checkIsWeb } from '../appRedux/actions/MobAppFn'
import ds from '../Services/DataServices'
import { PRODUCT_SCREEN } from '../constants/Pages'

const ProductSearch = props => {
  const { pageID, changeStatus, noChild, isPromo, screen } = props
  const dispatch = useDispatch()
  const searchBy =
    props && props.searchBy
      ? props.searchBy
      : PROD_SEARCH_ENTITIES.Search_By_Product
  const searchFrom =
    props && props.searchFrom
      ? props.searchFrom
      : AUTOCOMPLETE_SEARCH_FROM.DEFAULT

  const getReduxSelectedStoreOutlets = useSelector(
    ({ Sell }) => Sell.openCloseSelectedStoreOutlets
  )

  const [products, setProducts] = useState([])
  const [searchTerm, setSearchTerm] = useState('')
  const [options, setOptions] = useState([])
  const [getSelectedOutlet, setSelectedOutlet] = React.useState('')

  React.useEffect(() => {
    let outletID = ''
    if (getReduxSelectedStoreOutlets.id) {
      outletID = getReduxSelectedStoreOutlets.id
      setSelectedOutlet(outletID)
    } else {
      let selectedLocalOut = localStorage.getItem('selectedOut')
      if (selectedLocalOut) {
        selectedLocalOut = JSON.parse(selectedLocalOut)
        outletID = getReduxSelectedStoreOutlets.id
          ? getReduxSelectedStoreOutlets.id
          : selectedLocalOut.id

        setSelectedOutlet(outletID)
      }
    }
  }, [getReduxSelectedStoreOutlets])

  // useEffect(() => {
  //   const fetchProductsFromIndexDB = async () => {
  //     const indexedDBProducts = await getProductsFromIndexedDB();
  //     if (indexedDBProducts.length > 0) {
  //       setProducts(indexedDBProducts);
  //     } else {
  //       dispatch(loadFetchProducts());
  //     }
  //   };
  //   fetchProductsFromIndexDB();
  // }, []);

  // const getProductsFromIndexedDB = async () => {
  //   return new Promise((resolve, reject) => {
  //     const request = window.indexedDB.open(INDEX_DB_NAME, 1);
  //     request.onerror = (event) => {
  //       console.error("IndexedDB error:", event.target.error);
  //       reject(event.target.error);
  //     };
  //     request.onsuccess = (event) => {
  //       const db = event.target.result;
  //       const transaction = db.transaction(
  //         INDEX_DB_TABLES.PRODUCTS,
  //         "readonly"
  //       );
  //       const objectStore = transaction.objectStore(INDEX_DB_TABLES.PRODUCTS);
  //       const getRequest = objectStore.getAll();
  //       getRequest.onsuccess = (event) => {
  //         resolve(event.target.result);
  //       };
  //       getRequest.onerror = (event) => {
  //         console.error("IndexedDB error:", event.target.error);
  //         reject(event.target.error);
  //       };
  //     };
  //   });
  // };

  // const handleSearch = async () => {
  //   const indexedDBProducts = await getProductsFromIndexedDB();

  //   const filteredProducts = indexedDBProducts.filter((product) =>
  //     product.productName.toLowerCase().includes(searchTerm.toLowerCase())
  //   );

  //   if (filteredProducts.length === 0) {
  //     const apiProducts = await getProductsFromAPI();

  //     const filteredApiProducts = apiProducts.filter((product) =>
  //       product.productName.toLowerCase().includes(searchTerm.toLowerCase())
  //     );

  //     setProducts(filteredApiProducts);
  //   } else {
  //     setProducts(filteredProducts);
  //   }
  // };
  // function DesignComponent({
  //   Design = "default",
  //   currency
  // }) {
  //   const myComponents = {
  //     FullWidth: (
  //       <FullWidthDesign
  //         currency={currency}
  //       />
  //     ),
  //     default: <FullWidthDesign />,
  //   };
  //   return myComponents[Design];
  // }

  const onSelect = (value, option) => {
    delete option.label //Remove Extra Object from Option Object
    option.searchFrom = searchFrom
    option.entityID = isString(searchBy) ? parseInt(searchBy) : searchBy
    if (
      pageID &&
      pageID == PRODUCT_SCREEN &&
      changeStatus &&
      option &&
      !isEmptyObject(option)
    ) {
      changeStatus(option.isActive ? 1 : 0)
    }
    if (searchBy == PROD_SEARCH_ENTITIES.Search_By_Brand) {
      if (option.brandID) {
        option.productID = `${option.brandID}&&_9efa-1ea9-4faf-88ed-a48e65b46643`
        option.productName = option.brandName ? option.brandName : ''
      }
    } else if (searchBy == PROD_SEARCH_ENTITIES.Search_By_Category) {
      if (option.catID) {
        option.productID = `${option.catID}&&_9efa-1ea9-4faf-88ed-a48e65b46643`
        option.productName = option.catName ? option.catName : ''
      }
    } else if (searchBy == PROD_SEARCH_ENTITIES.Search_By_Supplier) {
      if (option.supplierID) {
        option.productID = option.supplierID
        option.productName = option.supplierName ? option.supplierName : ''
      }
    } else if (searchBy == PROD_SEARCH_ENTITIES.Search_By_Tags) {
      if (option.tagID) {
        option.productID = `${option.tagID}&&_9efa-1ea9-4faf-88ed-a48e65b46643`
        option.productName = option.tagName ? option.tagName : ''
      }
    }
    dispatch(loadSearchSelectedProduct(option))
    if (isPromo) setOptions([])
    // dispatch(loadSearchSelectedProduct([]));
  }
  const handleSearch = searchQuery => {
    setOptions([])
    if (isPromo) searchOnServer(searchQuery)
    else {
      const request = window.indexedDB.open(INDEX_DB_NAME, CURRENT_VERSION)
      request.onerror = event => {
        console.error('IndexedDB error:', event.target.error)
        searchOnServer(searchQuery)
      }
      request.onsuccess = event => {
        const db = request.result
        let tabName = ''
        let tabIndex = ''
        if (
          searchBy == PROD_SEARCH_ENTITIES.Search_By_Product ||
          searchBy == PROD_SEARCH_ENTITIES.Search_By_SKUs
        ) {
          tabName = INDEX_DB_TABLES.PRODUCTS
          tabIndex = PRODUCT_NAME_INDEX
        }
        if (searchBy == PROD_SEARCH_ENTITIES.Search_By_Brand)
          tabName = INDEX_DB_TABLES.BRANDS
        if (searchBy == PROD_SEARCH_ENTITIES.Search_By_Category)
          tabName = INDEX_DB_TABLES.PRODUCTTYPES
        if (searchBy == PROD_SEARCH_ENTITIES.Search_By_Tags)
          tabName = INDEX_DB_TABLES.PRODUCTTAGS
        if (searchBy == PROD_SEARCH_ENTITIES.Search_By_Supplier)
          tabName = INDEX_DB_TABLES.SUPPLIER
        if (!db.objectStoreNames.contains(tabName)) {
          console.error(
            `Object store ${tabName} does not exist in the database.`
          )
          searchOnServer(searchQuery)
          return
        }
        const transaction = db.transaction(INDEX_DB_TABLES.PRODUCTS, 'readonly')
        const objectStore = transaction.objectStore(INDEX_DB_TABLES.PRODUCTS)
        const searchIndex = objectStore.index(PRODUCT_NAME_INDEX)
        const results = []
        searchIndex.openCursor().onsuccess = event => {
          const cursor = event.target.result

          if (cursor) {
            const product = cursor.value
            // Perform your search logic here
            if (
              (product.productName &&
                product.productName
                  .toLowerCase()
                  .includes(searchQuery.toLowerCase())) ||
              (product.variantName &&
                product.variantName
                  .toLowerCase()
                  .includes(searchQuery.toLowerCase()))
            ) {
              let allow = false

              if (pageID == PRODUCT_SCREEN) {
                allow = true
              } else if (product.isActive && product.isActiveOnSale) {
                if (noChild) {
                  // _isPB
                  if (!product.hasChild) allow = true
                } else allow = true
              }

              if (allow) {
                results.push(product)
              }
            }

            cursor.continue()
          } else {
            let nameArray = []

            if (results.length > 0) {
              // setSearchProd(getSearchProd.concat(searchProducts.data.data));
              nameArray = getProdsArray(results)
            } else {
              //Here We Call the API that products doesnt exist in the List
              const body = {
                ProductSearchText: searchQuery
              }

              dispatch(loadFetchProducts(body))
            }
            //console.log("Products Search Data", nameArray);
            setOptions(nameArray)
            //setSearchResults(results);
          }
        }
      }
    }
  }
  const searchOnServer = async (value, isSKUSearch) => {
    if (value) {
      if (getSelectedOutlet) {
        let nameArray = []
        let searchProducts = {
          data: {
            msgCode: '',
            msgDescription: ''
          }
        }
        await ds
          .getBookSearchProd(
            `?keys=${value}&outletid=${getSelectedOutlet}${
              pageID ? `&pageID=${pageID}` : ''
            }${noChild ? `&isPB=${true}&searchBy=${searchBy}` : ''}`
          )
          .then(response => (searchProducts.data = response.data))
          .catch(e => {
            //  console.log("Product Search Issue", e)
          })

        if (searchProducts.data.msgCode == 'GENERAL_SUCCESS') {
          if (searchProducts.data.data && searchProducts.data.data.length > 0) {
            // setSearchProd(getSearchProd.concat(searchProducts.data.data))
            nameArray = getProdsArray(searchProducts.data.data)
            // searchProducts.data.data.map(names => {
            //   const category = names.productName
            //   const id = names.productID
            //   return {
            //     value: category,
            //     label: (
            //       <div
            //         style={{
            //           display: 'flex',
            //           justifyContent: 'space-between'
            //         }}
            //       >
            //         <span
            //           style={{
            //             backgroundColor: 'lightcyan',
            //             fontStyle: 'oblique',
            //             fontWeight: 'bolder'
            //           }}
            //         >
            //           <a>{category}</a>
            //         </span>
            //         <span>
            //           <IntlMessages id='products.addeditpriceprod.searchresult' />
            //         </span>
            //       </div>
            //     )
            //   }
            // })
            if (isSKUSearch) {
              // BarCodeSelect(searchProducts.data.data)
            }
          } else {
            if (isSKUSearch) {
              message.error("SKU doesn't exist")
            }
          }
          setOptions(nameArray)
        }

        if (searchProducts.data.msgCode == 'GENERAL_ERROR') {
          message.error(searchProducts.data.msgDescription)
        }
      } else {
        message.warn('Kindly click on Sell & select Outlet from left side', 3)
      }
    } else {
      setOptions([])
    }
  }

  function getProdsArray (data) {
    return data && data.length > 0
      ? data.map(names => {
          let search_by_tag = 'Searched By Product'
          let bgColor = 'lightcyan'
          if (searchBy && searchBy == PROD_SEARCH_ENTITIES.Search_By_Category) {
            // bgColor = 'gray'
            search_by_tag = 'Searched By Category'
          }
          if (searchBy && searchBy == PROD_SEARCH_ENTITIES.Search_By_Brand) {
            // bgColor = 'orange'
            search_by_tag = 'Searched By Brand'
          }
          if (searchBy && searchBy == PROD_SEARCH_ENTITIES.Search_By_Supplier) {
            // bgColor = 'yellow'
            search_by_tag = 'Searched By Supplier'
          }
          if (searchBy && searchBy == PROD_SEARCH_ENTITIES.Search_By_Tags) {
            // bgColor = 'purple'
            search_by_tag = 'Searched By Tag'
          }
          let fullProductName = ''
          if (
            searchBy == PROD_SEARCH_ENTITIES.Search_By_Product ||
            searchBy == PROD_SEARCH_ENTITIES.Search_By_SKUs
          ) {
            fullProductName = `${names.productName}  ${
              !StringIsNullOrEmpty(names.variantName)
                ? `- ${names.variantName}`
                : ''
            } `
          } else if (searchBy == PROD_SEARCH_ENTITIES.Search_By_Category)
            fullProductName = names.categoryName ? names.categoryName : ''
          else if (searchBy == PROD_SEARCH_ENTITIES.Search_By_Brand)
            fullProductName = names.brandName ? names.brandName : ''
          else if (searchBy == PROD_SEARCH_ENTITIES.Search_By_Supplier)
            fullProductName = names.supplierName ? names.supplierName : ''
          else if (searchBy == PROD_SEARCH_ENTITIES.Search_By_Tags)
            fullProductName = names.tagName ? names.tagName : ''
          return {
            productName: names.productName,
            // value: `${names.productName}${
            //   !StringIsNullOrEmpty(names.variantName)
            //     ? '-' + names.variantName
            //     : ''
            // }`,
            value: fullProductName,
            variantName: names.variantName,
            productID: names.id ? names.id : names.productID,
            hasChild: names.hasChild,
            parentProductID: names.parentProductID,
            isVariant: names.isVariant,
            isActive: names.isActive,
            catID: names.categoryID ? names.categoryID : 0,
            catName: names.categoryName ? names.categoryName : 0,
            brandID: names.brandID ? names.brandID : 0,
            brandName: names.brandName ? names.brandName : 0,
            tagID: names.tagID ? names.tagID : 0,
            tagName: names.tagName ? names.tagName : 0,
            supplierID:
              names.supplierID && getDecryptID(names.supplierID)
                ? parseInt(getDecryptID(names.supplierID))
                : 0,
            supplierName: names.supplierName ? names.supplierName : '',
            label: (
              <div
                style={{
                  display: 'flex',
                  justifyContent: 'space-between'
                }}
              >
                <span
                  style={{
                    backgroundColor: bgColor,
                    fontStyle: 'oblique',
                    fontWeight: 'bolder'
                  }}
                >
                  <a>{fullProductName}</a>
                  {isPromo && (
                    <sup
                      style={{
                        fontSize: 'small',
                        marginLeft: 12,
                        fontWeight: 'normal'
                      }}
                    >
                      {search_by_tag}
                    </sup>
                  )}
                  {(searchBy == PROD_SEARCH_ENTITIES.Search_By_Product ||
                    searchBy == PROD_SEARCH_ENTITIES.Search_By_SKUs) &&
                    !names.isActive && (
                      <span
                        style={{
                          backgroundColor: 'rgb(251 26 26 / 71%)'
                        }}
                      >
                        {`    not active`}
                      </span>
                    )}
                </span>
                <span>
                  <IntlMessages id='products.addeditpriceprod.searchresult' />
                </span>
              </div>
            )
          }
        })
      : []
  }

  // const handleSearchnew= async (searchQuery) => {
  //    setOptions([]);
  //    if (searchQuery.length >= 2) {
  //     const searchColumns = ['productName', 'variantName']; // Add your column names here
  //     const results = await autocompleteSearch(INDEX_DB_NAME, INDEX_DB_TABLES.PRODUCTS, CURRENT_VERSION, searchQuery, searchColumns);
  //     let nameArray = [];
  //     if (results.length > 0) {
  //
  //       // setSearchProd(getSearchProd.concat(searchProducts.data.data));
  //       nameArray = results.map((names) => {
  //         const fullProductName = `${names.productName}  ${
  //           !StringIsNullOrEmpty(names.variantName)
  //             ? `- ${names.variantName}`
  //             : ""
  //         } `;
  //         return {
  //           productName: names.productName,
  //           value: `${names.productName}${
  //             !StringIsNullOrEmpty(names.variantName)
  //               ? "-" + names.variantName
  //               : ""
  //           }`,
  //           variantName: names.variantName,
  //           productID: names.id,
  //           parentProductID: names.parentProductID,
  //           isVariant: names.isVariant,
  //           label: (
  //             <div
  //               style={{
  //                 display: "flex",
  //                 justifyContent: "space-between",
  //               }}
  //             >
  //               <span
  //                 style={{
  //                   backgroundColor: "lightcyan",
  //                   fontStyle: "oblique",
  //                   fontWeight: "bolder",
  //                 }}
  //               >
  //                 <a>{fullProductName}</a>
  //               </span>
  //               <span>
  //                 <IntlMessages id="products.addeditpriceprod.searchresult" />
  //               </span>
  //             </div>
  //           ),
  //         };
  //       });
  //     } else {
  //       //Here We Call the API that products doesnt exist in the List
  //       const body = {
  //         ProductSearchText: searchQuery,
  //       };

  return (
    <>
      <Form.Item
        className='ant-form-item-label-custom '
        name='ProductSearch'
        label={
          props.isLabel ? (
            <IntlMessages id='products.main.add.ProductSearch' />
          ) : (
            ''
          )
        }
      >
        <AutoComplete
          className='certain-category-search'
          dropdownClassName='certain-category-search-dropdown'
          dropdownMatchSelectWidth={true}
          allowClear={true}
          autoClearSearchValue
          // autoFocus={checkIsWeb().exist}
          notFoundContent={
            <IntlMessages id='products.addeditpriceprod.noprodfound' />
          }
          options={options}
          onSelect={onSelect}
          onSearch={handleSearch}
        >
          <Input
            className='Products-Search-bar'
            placeholder='Search or Scan for products'
            prefix={<i className='icon icon-search' />}
          />
        </AutoComplete>
      </Form.Item>
    </>
  )
}

export default ProductSearch
